angular.module("vgresiduos").factory("measureUnitService", [
	"$http",
	"$q",
	"localStorageWithTimeoutService",
	function ($http, $q, localStorageWithTimeoutService) {
		"use strict";

		const measureUnitsCacheKey = Vgr.constants.cacheKeysPrefix.measureUnits;
		const cacheTimeoutInMinutes = 43200;

		const _listMeasureUnits = function (dto) {
			return Vgr.util
				.getWithCache(
					Vgr.constants.coreHostUrl + Vgr.resources.core.measureUnits,
					dto,
					measureUnitsCacheKey,
					cacheTimeoutInMinutes,
					localStorageWithTimeoutService,
					$http,
					$q
				)
				.then(function (response) {
					return {
						...response,
						data: {
							MeasureUnits: response.data.map(Vgr.dtoMappings.measureUnit.fromCoreToV2)
						}
					};
				});
		};

		return {
			listMeasureUnits: _listMeasureUnits
		};
	}
]);
